import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import { Sensor, UpdateSensor, Parking } from '../../entity';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { IParking } from "../../entity/parking";
import { IParkingLotGroup } from "../../entity/parking-lot";

@Injectable()
export class ParkingsService {

    loadedParking: any = null;

    constructor(
        private http: Http,
        private httpClient: HttpClient,
        private authService: AuthService,
        private settings: SettingsService
    ) { }

    public query(): Observable<IParking[]> {
        const headers = new HttpHeaders()
            .set('LoginRole', `${this.authService.getUserLoginRole()}`)
            .set('Authorization', this.authService.getUserToken());

        return this.httpClient.get<IParking[]>(`${this.settings.serverNomenclator}v2/parking/query`, { headers });
    }

    public queryLotsGrouped(): Observable<IParkingLotGroup[]> {
        const headers = new HttpHeaders()
            .set('LoginRole', `${this.authService.getUserLoginRole()}`)
            .set('Authorization', this.authService.getUserToken());

        return this.httpClient.get<IParkingLotGroup[]>(`${this.settings.serverNomenclator}v2/parkinglot/query-grouped`, { headers });
    }

    getParkingLotDetail(parkingId: number) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Parking/GetParkingDetail?parkingId=${parkingId}`, { headers: headers })
            .map((res) => res.json());
    }

    getParkingLots() {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'Parking/GetParkingsOf', { headers: headers })
            .map((res) => res.json());
    }

    getParkingsV2() {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'v2/parking/getlistbyadmin', { headers: headers })
            .map((res) => res.json());
    }

    getParking(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(
            this.settings.serverNomenclator + 'Parking/GetParkingDetailedDescription?parkingId=' + id, { headers: headers })
            .map((res) => res.json());
    }

    getParkingSchedules(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Scheduler/GetByParking?parkingId=${id}`, { headers: headers })
            .map((res) => res.json());
    }

    getParkingTariffs(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}ParkingTariff/GetByParking?parkingId=${id}`, { headers: headers })
            .map((res) => res.json());
    }

    getParkingSensors(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}ParkingLotSensor/GetByParking?parkingId=${id}`, { headers: headers })
            .map((res) => res.json());
    }

    updateParkingLotSensor(parkingLotSensor) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(`${this.settings.serverNomenclator}ParkingLotSensor/Update`, parkingLotSensor, { headers: headers })
            .map((res) => res.json());
    }

    updateParkingTariff(parkingTariffId, edit) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(
            this.settings.serverNomenclator + 'ParkingTariff/Update?parkingTariffId=' + parkingTariffId, edit, { headers: headers })
            .map((res) => res.json());
    }

    removeParkingLots(lots) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(this.settings.serverNomenclator + 'ParkingLot/DeleteLots', lots, { headers: headers })
            .map(res => res.json());
    }
    generateParkingLots(lots) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(this.settings.serverNomenclator + 'ParkingLot/GenerateLots', lots, { headers: headers })
            .map(res => res.json());
    }
    updateParking(update) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(this.settings.serverNomenclator + 'Parking/UpdateParking', update, { headers: headers })
            .map(res => res.json());
    }

    deleteParkingLotSensor(sensor) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(
            `${this.settings.serverNomenclator}ParkingLotSensor/Delete?parkingLotSensorId=${sensor.ParkingLotSensorID}`,
            { headers: headers });
    }

    getSensorProfile(sensorId: string) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Sensor/GetByID?sensorId=${sensorId}`, { headers: headers })
            .map((res) => res.json());
    }

    getSensorHistory(sensorId: string) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Sensor/GetSensorTransactions?sensorId=${sensorId}`, { headers: headers })
            .map((res) => res.json());
    }

    getByAdmin() {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Parking/GetByAdmin`, { headers: headers })
            .map((res) => res.json());
    }

    getSensorsByParkingId(parkingId: number) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Sensor/GetByParking?parkingId=${parkingId}`, { headers: headers })
            .map((res) => res.json());
    }

    registerSensor(sensor: Sensor) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(`${this.settings.serverNomenclator}Sensor/Add`, sensor, { headers: headers })
            .map(res => res.json());
    }

    updateSensor(sensor: UpdateSensor) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(`${this.settings.serverNomenclator}Sensor/Update`, sensor, { headers: headers })
            .map(res => res.json());
    }

    deleteSensor(sensorId: string) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(`${this.settings.serverNomenclator}Sensor/Delete?sensorId=${sensorId}`, { headers: headers })
            .map((res) => res.json());
    }
}
